import Features from '@core/tools/features';

;(function (undefined) {
    function FilterFakeSelect (options) {
        this.options = {
            $el: options.$el || null,
            labelSeparator: ', '
        };

        this.initialize();
    }

    FilterFakeSelect.prototype = {
        constructor: FilterFakeSelect,

        initialize: function () {
            var title;
            var $title;
            var $list;
            var $listElements;
            var lbl;
            var colors;
            var self = this;

            $title = this.options.$el.find('> h5');
            title = $title.text().trim();
            this.options.$el.removeClass().addClass('multiselect');

            var $newSpan = $('<span></span>');

            $.each($title[0].attributes, function() {
                if (this.specified) $newSpan.attr(this.name, this.value);
            });

            $newSpan.html($title.html());
            $title.replaceWith($newSpan);

            $title = this.options.$el.find('> span');

            $list = this.options.$el.find('> ul');
            this.options.$el.on('mousedown', function (ev) {
                self.toggleFilter(ev, $list, self);
            });
            this.options.$el.on('keydown', function (ev) {
                if (ev.key !== 'Enter' && ev.key !== ' ') return;

                ev.preventDefault();

                self.toggleFilter(ev, $list, self);
            });

            this.options.$el.find('a').each((index, element) => {
                $(element).on('keydown', function(ev) {
                    if (ev.key !== 'Enter' && ev.key !== ' ') return;

                    ev.stopPropagation();
                });
            });

            $list.on('keydown', function (ev) {
                if (ev.key !== 'Escape') return;
                
                self.hideFilter($list, self);
            });

            if (this.$title) {
                this.$title.on('mousedown', function (ev) {
                    self.toggleFilter(ev, $list, self);
                });
                this.$title.on('keydown', function (ev) {
                    if (ev.key !== 'Enter' && ev.key !== ' ') return;

                    ev.preventDefault();

                    self.toggleFilter(ev, $list, self);
                });
            }

            document.addEventListener('focusin', (ev) => self.handleFocusIn(ev, $list, self))

            lbl = [];
            colors = false;
            $listElements = this.options.$el.find('.selected span');
            $listElements.each(function () {
                if ($(this).data('color')) {
                    lbl.push($(this).data('color'));
                    colors = true;
                } else {
                    lbl.push($(this).text().trim());
                }
            });

            if (lbl.length === 0) {
                $title.html(title + ': (' + Shop.lang.common.product_stock_select + ')');
            } else {
                if (!colors) {
                    this.adjustLabels(this.options.$el, lbl, title, $title);
                } else {
                    $title.html(title + ': ');

                    lbl.forEach(function (color) {
                        $('<span />', {
                            'class': 'color-filter'
                        }).appendTo($title).css('background-color', color);
                    });
                }
            }
        },

        showFilter: function(ev, $list, self) {
            const parentId = $(ev.currentTarget).attr('id');
            $('.multiselect:not(#' + parentId + ') > ul').hide();

            $list.show();

            self.handleAriaOpened(self, $list);
        },

        hideFilter: function($list, self) {
            const isCurrentlyVisible = $list.is(':visible');

            if (!isCurrentlyVisible) return;

            $list.hide();

            self.handleAriaClosed(self, $list);

            const isFocusWithinFilter = this.options.$el[0].contains(document.activeElement);

            if (isFocusWithinFilter) this.options.$el.find('span')[0].focus();
        },

        toggleFilter: function(ev, $list, self) {
            const hasClickedOnMultiselectContainer = ev.currentTarget === ev.target;
            const hasClickedOnTriggerElement = $(ev.target).parent()[0] === ev.currentTarget && ev.target.tagName !== 'UL';

            const shouldToggle = hasClickedOnMultiselectContainer || hasClickedOnTriggerElement;

            if (!shouldToggle) return;

            const isCurrentlyVisible = $list.is(':visible');

            if (isCurrentlyVisible) {
                self.hideFilter($list, self);
            } else {
                self.showFilter(ev, $list, self);
            }
        },

        handleAriaOpened: function(self, $list) {
            const $title = self.options.$el.find('span[role="button"]');
            $title.attr('aria-expanded', 'true');
            $list.find('a').first().focus();
        },

        handleAriaClosed: function(self, $list) {
            const $title = self.options.$el.find('span[role="button"]');
            $title.attr('aria-expanded', 'false');
        },

        handleFocusIn: function(ev, $list, self) {
            const $title = self.options.$el.find('span');
            const isExpanded = $title[0].getAttribute('aria-expanded') === 'true';

            const $currentlyFocusedElement = ev.target;

            if (!self.options.$el[0].contains(ev.target)) {
                self.hideFilter($list, self);
            }
        },

        adjustLabels: function (select, lbl, headText, span) {
            var containerWidth;
            var $fakeContainer;
            var lblLength;
            var firstLbl;
            var dots;

            dots = '';
            firstLbl = lbl[0];
            containerWidth = select.width();
            $fakeContainer = $('<span />', {
                text: headText + ': ' + lbl.join(this.options.labelSeparator)
            }).appendTo($('body'));

            if (($fakeContainer.width() + 50) > containerWidth) {
                dots = ' [...]';
            }

            lblLength = lbl.length;
            while (($fakeContainer.width() + 50) > containerWidth) {
                lbl = lbl.slice(0, lblLength - 1);
                $fakeContainer.text(headText + ': ' + lbl.join(this.options.labelSeparator));
                lblLength = lbl.length;

                if (lbl.length <= 0) {
                    break;
                }
            }

            if (lbl.length <= 0) {
                $fakeContainer.text(headText + ': ' + firstLbl);
                while (($fakeContainer.width() + 50) > containerWidth) {
                    firstLbl = firstLbl.slice(0, firstLbl.length - 1);
                    $fakeContainer.text(headText + ': ' + firstLbl);

                    if (firstLbl.length <= 0) {
                        break;
                    }
                }

                span.html(headText + ': ' + Shop.fn.simpleSanitizeHTML(firstLbl) + dots);
            } else {
                span.html(headText + ': ' + lbl.join(this.options.labelSeparator) + dots);
            }

            $fakeContainer.remove();
        }
    };

    Shop.Filter.include({
        options: {
            limit: 5,
            fakeSelect: 0,

            selectors: {
                box: '#box_filter',
                groups: '#box_filter .group-filter',
                ulGroups: '> ul',
                item: 'li',
                itemSelected: 'selected',
                itemHide: 'none'
            },

            elements: {
                $box: null,
                $groups: null,
                $ulGroups: null
            }
        },

        initialize: function (options) {
            var self;

            this.constructor.setOptions(options);

            this.options.elements.$box = $(this.options.selectors.box);
            this.options.elements.$groups = $(this.options.selectors.groups);
            this.options.elements.$ulGroups = this.options.elements.$groups.find(this.options.selectors.ulGroups);
            this.options.fakeSelect = parseInt(this.options.elements.$box.data('selectDisplay'), 10);
            this.options.limit = parseInt(this.options.elements.$box.data('limit'), 10);

            if (this.options.fakeSelect === 1) {
                self = this;
                this.options.elements.$groups.each(function () {
                    if (!this.FilterFakeSelect) {
                        this.FilterFakeSelect = new FilterFakeSelect({
                            $el: $(this)
                        });
                    }
                });

                $(window).on('click', function (ev) {
                    if (!$(ev.target).hasClass('multiselect') && $(ev.target).parents('.multiselect').length <= 0) {
                        self.options.elements.$groups.find('> ul').hide();
                    }
                });
            }

            this.hide();
            this.options.elements.$box.removeClass('loading');

            if (Features.isEnabled('dev_core_hide_filters')) {
                const base64 = this.parent.base64;
                const base64HrefPattern = /^(?:[A-Za-z0-9+/]{4})*(?:[A-Za-z0-9+/]{2}==|[A-Za-z0-9+/]{3}=)?$/;
                const getNormalizedBase64Href = function (value) {
                    if (typeof value !== 'string') return null;

                    const normalizedValue = value.trim().replace(/\s+/g, '');

                    if (normalizedValue.length === 0) {
                        return '';
                    }

                    if (normalizedValue.length % 4 !== 0) {
                        return null;
                    }

                    return base64HrefPattern.test(normalizedValue) ? normalizedValue : null;
                };
                const isAllowedDecodedHref = function (value) {
                    if (typeof value !== 'string') {
                        return false;
                    }

                    const normalizedValue = value.trim();

                    if (normalizedValue.length === 0) {
                        return true;
                    }

                    if (/^(?:javascript|data|vbscript):/i.test(normalizedValue) || normalizedValue.indexOf('//') === 0) {
                        return false;
                    }

                    try {
                        const parsedUrl = new URL(normalizedValue, window.location.origin);
                        const isHttpProtocol = parsedUrl.protocol === 'http:' || parsedUrl.protocol === 'https:';

                        return isHttpProtocol && parsedUrl.origin === window.location.origin;
                    } catch (err) {
                        return false;
                    }
                };

                this.options.elements.$box.find('[data-href]').each((index, element) => {
                    // if any 3rd party script relies on reading href attribute it will still work due to overriding href getter and getAttribute method
                    // console.log($(element).attr('href'));
                    // console.log($(element).prop('href'));
                    // console.log(element.href);
                    // console.log(element.getAttribute('href'));

                    const originalGetAttribute = element.getAttribute;
                    const getDecodedHref = function (targetElement) {
                        const encodedHref = originalGetAttribute.call(targetElement, 'data-href');
                        const normalizedEncodedHref = getNormalizedBase64Href(encodedHref);

                        if (normalizedEncodedHref === null) {
                            return null;
                        }

                        const decodedHref = base64.decode(normalizedEncodedHref);

                        if (!isAllowedDecodedHref(decodedHref)) {
                            return null;
                        }

                        return decodedHref;
                    };
                    const getSafeHref = function (targetElement) {
                        const decodedHref = getDecodedHref(targetElement);

                        if (decodedHref === null) {
                            return originalGetAttribute.call(targetElement, 'href');
                        }

                        return decodedHref;
                    };
                    const materializeHref = function (targetElement) {
                        const decodedHref = getDecodedHref(targetElement);

                        if (decodedHref === null) {
                            return null;
                        }

                        targetElement.setAttribute('href', decodedHref);

                        return decodedHref;
                    };

                    Object.defineProperty(element, 'href', {
                        get: function () {
                            return getSafeHref(this);
                        }
                    });

                    element.getAttribute = function (name) {
                        if (name === 'href') {
                            return getSafeHref(this);
                        }

                        return originalGetAttribute.call(this, name);
                    };

                    $(element).on('mouseenter focus pointerdown touchstart click', function () {
                        try {
                            materializeHref(this);
                        } catch (err) {
                            console.error(err);
                        }
                    });

                    $(element).on('keydown', function (ev) {
                        if (ev.key !== 'Enter' && ev.key !== ' ') {
                            return;
                        }

                        try {
                            const decodedHref = materializeHref(this);

                            if (ev.key === ' ' && decodedHref !== null) {
                                ev.preventDefault();
                                window.location.assign(decodedHref);
                            }
                        } catch (err) {
                            console.error(err);
                        }
                    });
                });
            }
        },

        hide: function () {
            var self;
            var lists;

            self = this;
            lists = [];

            this.options.elements.$groups.each(function () {
                if ($(this).data('limit')) {
                    lists.push({
                        list: $(this).find(self.options.selectors.item),
                        limit: $(this).data('limit')
                    });
                } else if (self.options.limit > 0) {
                    lists.push({
                        list: $(this).find(self.options.selectors.item)
                    });
                }
            });

            this.parent.forEachIn(lists, function (obj) {
                self.hideList(obj.list, obj.limit);
            });
        },

        showList: function (list) {
            list.removeClass(this.options.selectors.itemHide);
            list.$button.text(Shop.lang.filter.show_less);
            list.$button.attr('aria-label', Shop.lang.filter.show_less_aria_label);
            list.collapsed = false;
        },

        hideList: function (list, limit) {
            var self;
            var listLength;
            var numberToHide;
            var lastItem;
            var $item;

            self = this;
            listLength = list.length;
            limit = limit || self.options.limit;

            if (listLength > limit) {
                numberToHide = listLength - limit;
                lastItem = listLength - 1;

                if (!!list.find('em').length) {
                    list.sort(self.sort.bind(this));
                }

                while (numberToHide > 0) {
                    $item = $(list[lastItem]);

                    if ($item.length === 0) {
                        break;
                    }

                    if (!$item.hasClass(self.options.selectors.itemSelected)) {
                        $item.addClass(self.options.selectors.itemHide);
                        numberToHide -= 1;
                    }

                    lastItem -= 1;
                }

                if (numberToHide !== listLength - limit) {
                    if (!list.$button) {
                        list.$button = $('<li />', {
                            'text': Shop.lang.filter.show_more,
                            'class': 'showmore',
                            'tabindex': 0,
                            'aria-label': Shop.lang.filter.show_more_aria_label
                        }).appendTo(list.parent()).on('click keydown', function (ev) {
                            if (ev.type !== 'click' && ev.key !== 'Enter' && ev.key !== " ") return;
                            
                            ev.preventDefault();
                            ev.stopPropagation();

                            if (list.collapsed === true) {
                                self.showList(list);
                            } else {
                                self.hideList(list, limit);
                            }
                        });
                    } else {
                        list.$button.text(Shop.lang.filter.show_more);
                        list.$button.attr('aria-label', Shop.lang.filter.show_more_aria_label);
                    }
                }

                list.collapsed = true;
            };
        },

        sort: function (x, y) {
            var xv;
            var yv;

            x = $(x);
            y = $(y);
            xv = parseInt(x.find('em').text().replace(/[^0-9]/g, ''), 10);
            yv = parseInt(y.find('em').text().replace(/[^0-9]/g, ''), 10);

            if (!xv) {
                xv = 0;
            }

            if (!yv) {
                yv = 0;
            }

            return yv - xv;

        }
    });
})();